import { createContext } from "react";

const ThemeContext = createContext("");

export { ThemeContext };
